import type { FC } from "react";
import type { RegisterOptions } from "react-hook-form";
import { Controller } from "react-hook-form";

import { Select } from "@ui/components/Inputs";

export type FormSelectProps = {
  id: string;
  label: string;
  placeholder?: string;
  disclaimer?: string;
  validationRules: RegisterOptions;
  dropdownValues: Array<{ value: string; label: string }>;
  dataTestId?: string;
};

export const FormSelect: FC<FormSelectProps> = ({
  id,
  label,
  placeholder,
  disclaimer,
  dropdownValues,
  validationRules,
  dataTestId = "",
}) => {
  return (
    <Controller
      name={id}
      defaultValue=""
      rules={validationRules}
      render={({ field, fieldState: { error } }) => (
        <Select
          {...field}
          id={id}
          label={label}
          data-testid={dataTestId || `${id}-select`}
          inputId={id}
          name={field.name}
          isSearchable={false}
          placeholder={placeholder}
          options={dropdownValues}
          isError={!!error}
          errorText={error?.message}
          isHelperTextVisible={true}
          helperText={disclaimer}
          isOptional={!validationRules.required}
        />
      )}
    />
  );
};
